import React, { Component } from 'react';

export const SummaryDivider = (props) => {
  return (
    <div className="pi-row" style={{paddingTop: '10px'}}>
      <div className="pi-col-sm-12"><h6 style={{marginBottom: '4px'}}>{props.labelText}</h6></div>
    </div>
  );
};